import * as i0 from '@angular/core';
import * as i1 from './badge.module';
import * as i2 from './badge.component';
export const ElBadgeModuleNgFactory:i0.NgModuleFactory<i1.ElBadgeModule> = (null as any);
var _decl0_0:i2.ElBadgeComponent = (<any>(null as any));
var _decl0_1:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_2:i0.ElementRef<any> = (<any>(null as any));
function _View_ElBadgeComponent_Host_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_0.primary;
  currVal_0;
  const currVal_1:any = _decl0_0.success;
  currVal_1;
  const currVal_2:any = _decl0_0.info;
  currVal_2;
  const currVal_3:any = _decl0_0.warning;
  currVal_3;
  const currVal_4:any = _decl0_0.danger;
  currVal_4;
  const currVal_5:any = _decl0_0.top;
  currVal_5;
  const currVal_6:any = _decl0_0.right;
  currVal_6;
  const currVal_7:any = _decl0_0.bottom;
  currVal_7;
  const currVal_8:any = _decl0_0.left;
  currVal_8;
  const currVal_9:any = _decl0_0.start;
  currVal_9;
  const currVal_10:any = _decl0_0.end;
  currVal_10;
}
function _View_ElBadgeComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_0.text;
  currVal_0;
}
